import { render, staticRenderFns } from "./PlanejamentoDeAulas.vue?vue&type=template&id=d8a3e3c4&scoped=true"
import script from "./PlanejamentoDeAulas.vue?vue&type=script&lang=js"
export * from "./PlanejamentoDeAulas.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoDeAulas.vue?vue&type=style&index=0&id=d8a3e3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a3e3c4",
  null
  
)

export default component.exports